import { render } from "./index.vue?vue&type=template&id=061d9684&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=061d9684&lang=css"
import "./index.vue?vue&type=style&index=1&id=061d9684&scoped=true&lang=less"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061d9684"]])

export default __exports__